import Base from './base'
import Request from '@utils/request'
import { toQueryString } from '@utils'

class Ticket extends Base {
  async create(data) {
    const response = await Request.post('/api/tickets', data)
    return response
  }

  async createMessage({ id, data }) {
    const response = await Request.post(`/api/tickets/${id}/messages`, data)
    return response
  }

  async getTicket (id, params = {}) {
    const url = `/api/tickets/${id}?${toQueryString(params)}`
    const response = await Request.get(url)

    return response
  }
}

export default new Ticket()
